<h2 class="pb-[2.5rem]">{{ 'mobilityRef.title' | transloco }}</h2>
<div
  class="flex flex-col md:flex-row w-full divide-y-2 md:divide-y-0 divide-x-0 md:divide-x-2 divide-vinciBlue-300 rounded-xl bg-white mb-[2.5rem]"
>
  <app-filter-result-section
    [title]="'mobilityRef.activity' | transloco"
    [filter]="mobilitySearchStore.activitiesFiltersSelected()"
    [filterExists]="mobilitySearchStore.activitiesFilterExists()"
    [textIfNoFilter]="'mobilityRef.noActivityFilterSelected' | transloco"
  ></app-filter-result-section>
  <app-filter-result-section
    [title]="'mobilityRef.location' | transloco"
    [filter]="mobilitySearchStore.locationFiltersSelected()"
    [filterExists]="mobilitySearchStore.locationFilterExists()"
    [textIfNoFilter]="'mobilityRef.noLocationFilterSelected' | transloco"
  ></app-filter-result-section>
</div>
<h2 class="pb-[1.5rem]">{{ 'mobilityRef.results' | transloco }}</h2>
@if(loading()) {
<div class="my-[6.25rem]"><loader /></div>
} @else { @if (mobilitySearchStore.anyResults()) {
@if(mobilitySearchStore.activitiesFilterExists()){
<app-language-filter
  [textToDisplayIfAnySelected]="'mobilityRef.spokenLanguagesOfTheMobilityRefs' | transloco"
  [availableLanguages]="languagesAvailable()"
  (updateResults)="updateResults($event)"
  class="mb-[2.5rem]"
></app-language-filter>
<p class="my-[2.5rem]">{{ 'mobilityRef.mobilityRefNotice' | transloco }}</p>
<div class="grid grid-cols-1 md:grid-cols-3 gap-[1.5rem]">
  @for (mobilityRef of resultsRandomlySorted(); track $index) {
  <app-contact-card
    [spId]="mobilityRef.spId"
    [name]="mobilityRef.firstName + ' ' + mobilityRef.lastName"
    [job]="mobilityRef.job"
    [mail]="mobilityRef.mail"
    [phoneNumber]="mobilityRef.phoneNumber"
    [languages]="mobilityRef.languages"
    [location]="mobilityRef.location"
    [bookingLink]="mobilityRef.bookingCalendarLink"
    [allowSaving]="true"
  ></app-contact-card
  >}
</div>

} } @else {
<p class="w-full text-center">
  {{ 'mobilityRef.noMobilityRefFound' | transloco }}
</p>
}}

<div class="flex justify-end my-[2.5rem]">
  <app-button
    [text]="'mobilityRef.restartCtaText' | transloco"
    [variant]="'secondary'"
    [icon]="'back'"
    [iconSize]="'1.5rem'"
    [size]="'sm'"
    (buttonClick)="redirectToResearch()"
  ></app-button>
</div>
